<button mat-button color="warn" (click)="showDetails()">{{text}}</button>
<button mat-button color="warn" (click)="snackBarRef.dismiss()">Close</button>
